import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  Home,
  ProjectIcons,
  ProjectLaflamme,
  ProjectKarin,
  ProjectUma,
  ProjectBloc,
  ProjectMedioze,
  ProjectCag
} from '@/views'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: '-active',
  scrollBehavior: (to, from, savedPosition) => (to.hash ? { selector: to.hash } : savedPosition || { x: 0, y: 0 }),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/project/icons',
      name: 'projectIcons',
      component: ProjectIcons
    },
    {
      path: '/project/acunpuncture-laflamme',
      name: 'projectLaflamme',
      component: ProjectLaflamme
    },
    {
      path: '/project/karin-merinat',
      name: 'projectKarin',
      component: ProjectKarin
    },
    {
      path: '/project/uma-yoga',
      name: 'projectUma',
      component: ProjectUma
    },
    {
      path: '/project/bloc-solutions',
      name: 'projectBloc',
      component: ProjectBloc
    },
    {
      path: '/project/medioze',
      name: 'projectMedioze',
      component: ProjectMedioze
    },
    {
      path: '/project/cag',
      name: 'projectCag',
      component: ProjectCag
    }
  ]
})

export default router
